import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import "./style/ActionComments.css";
import "react-quill/dist/quill.snow.css";
import "../../../src/App";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import {
  convertFirstLetterOfFullNameToCapital,
  customName,
  getColorFromId,
} from "../../helpers/commonHelpers";
import { formatDistanceToNow, parse } from "date-fns";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as constantMessages from "../../constants/constatntMessages";
import { MentionsInput, Mention } from "react-mentions";
import profileImage from "../../assets/images/profile.png";
import { handleApiError } from "../../helpers/errorResponseHelper";


const ActionComments = React.memo(
  ({ userData, actionId }) => {
    const location = useLocation();
    const actionData = useSelector((state) => state.action);
    const employeeData = useSelector((state) => state.user);

    const [isEditing, setIsEditing] = useState(false);
    const [comment, setComment] = useState("");
    const [errors, setErrors] = useState("");
    const [editCommentError, setEditCommentError] = useState("");
    const [commentsList, setCommentsList] = useState([]);
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editedComment, setEditedComment] = useState("");
    const [showFullDate, setShowFullDate] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [commentToDelete, setCommentToDelete] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isEditingSaving, setIsEditingSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [mentionedUsersEdited, setMentionedUsers] = useState([]);
    const [mentionedUsersState, setMentionedUsersState] = useState([]);
    const accessToken = localStorage.getItem("accessToken");

    const organizationId = employeeData?.userData?.organizationId;
    const [adminList, setAdminList] = useState([]);

    useEffect(() => {
      if (organizationId) {
        fetchAdminList(organizationId);
      }
    }, [organizationId]);

    const fetchAdminList = async (orgId) => {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }

      try {
        const url = `${process.env.REACT_APP_API_URL}/api/V1/employee/listOnlyAdmin/${orgId}`;
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        };

        const response = await axios.get(url, config);

        if (response.data.success) {
          const adminList = response.data.data;
          setAdminList(adminList);
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        if (handleApiError(error)) return;
      }
    };



const assignedUsers = actionData?.singleActionDetails?.assignedUserDetail || [];
const attendeesDetail = actionData?.singleActionDetails?.attendeesDetail || [];
const meetingCreatorId = actionData?.singleActionDetails?.meetingDetail?.createdById;

const meetingCreator = attendeesDetail.find(
  (attendee) => attendee._id === meetingCreatorId
);
// Step 1: Build attendees list (attendees + assigned users only) for `@All`
let attendees = [...attendeesDetail];

const assignedUsersArray = Array.isArray(assignedUsers) ? assignedUsers : [assignedUsers];

assignedUsersArray.forEach((user) => {
  if (user && user._id && user.name) {
    const alreadyExists = attendees.some((u) => u._id === user._id);
    if (!alreadyExists) {
      attendees.push(user);
    }
  }
});



// Step 2: Build full list for mention dropdown (attendees + assigned users + admins)
let allParticipantsMap = new Map();

// Add attendees
attendees.forEach((user) => {
  if (user && user._id) {
    allParticipantsMap.set(user._id, user);
  }
});

// Add admins to dropdown (but not to `attendees`)
adminList.forEach((admin) => {
  if (admin && admin._id && !allParticipantsMap.has(admin._id)) {
    allParticipantsMap.set(admin._id, admin);
  }
});

const allParticipants = Array.from(allParticipantsMap.values());

// Step 3: Build mentionData for dropdown
const mentionData = [
  {
    id: "all",
    display: "All(attendee)",
    custom: "All",
    profilePicture: "",
  },
  ...allParticipants.map((user) => ({
    id: user._id,
    display: user.name,
    email: user.email,
    custom: customName(user.name),
    profilePicture: user.profilePicture,
  })),
];



    useEffect(() => {
      fetchComments();
    }, [actionId]);


    const fetchComments = async () => {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      try {
        const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/viewActionComment/${actionId}`;
        const headerObject = {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        };
        const response = await axios.get(webApiUrl, headerObject);
        if (response.data.success) {
          setCommentsList(response.data.data?.viewActionCommentList || []);
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        if (handleApiError(error)) return;
      }
    };

    const handleCommentChange = (
      event,
      newValue,
      newPlainTextValue,
      mentions
    ) => {
      //alert("handleCommentChange")
      const htmlOrSpecialCharsRegex = /<[^>]*>|[&<>]/g;
      if (newPlainTextValue.length > 500) {
        setErrors("Comment cannot exceed 500 characters.");
        return;
      }

      if (newPlainTextValue.length < 3) {
        setErrors("Comment must be at least 3 characters long.");
      } else if (htmlOrSpecialCharsRegex.test(newPlainTextValue)) {
        setErrors("HTML tags & Special letters are not allowed!");
      } else {
        setErrors("");
      }

      setComment(newValue);
      setIsEditing(true);
      setEditingCommentId(false);
      setComment(newPlainTextValue);
      setIsEditing(true);
      setEditingCommentId(false);
    };




    const handleEditCommentChange = (
      event,
      newValue,
      newPlainTextValue,
      mentions
    ) => {

      const htmlOrSpecialCharsRegex = /<[^>]*>|[&<>]/g;
      if (newPlainTextValue.length > 500) {
        setEditCommentError("Comment cannot exceed 500 characters.");
        return;
      }

      if (newPlainTextValue.length < 3) {
        setEditCommentError("Comment must be at least 3 characters long.");
      } else if (htmlOrSpecialCharsRegex.test(newPlainTextValue)) {
        setEditCommentError("HTML tags & Special letters are not allowed!");
      } else {
        setEditCommentError("");
      }

      setEditedComment(newPlainTextValue);

      const updatedMentionedUsers = mentions.map((user) => {
        const matchedUser = attendees.find(
          (attendee) => attendee._id === user.id
        );
        return {
          name: matchedUser?.name,
          id: user.id,
          email: matchedUser?.email,
        };
      });

      setMentionedUsers(updatedMentionedUsers);
      setErrors("");
    };


const handleEditComment = (
  commentId,
  commentDescription,
  mentionedUsers = [],
  allMention = { mentionedUsers: [] },
  singleMention = { mentionedUsers: [] }
) => {

  let formattedParts = [];



  // Handle @All
  if (allMention?.mentionedUsers?.length > 0) {
    const allMessage = allMention.mentionedUsers[0]?.message?.trim() || "";
    formattedParts.push(`@All${allMessage ? ` ${allMessage}` : ""}`);
  }

  //  Handle single mentions (each user separately)
  if (singleMention?.mentionedUsers?.length > 0) {
    singleMention.mentionedUsers.forEach((u) => {
      formattedParts.push(`@${u.name}${u.message ? ` ${u.message}` : ""}`);
    });
  }

  //  Fallback for old data
  if (
    allMention?.mentionedUsers?.length === 0 &&
    singleMention?.mentionedUsers?.length === 0 &&
    mentionedUsers.length > 0
  ) {
    mentionedUsers.forEach((u) => {
      formattedParts.push(`@${u.name}${u.message ? ` ${u.message}` : ""}`);
    });
  }

  const formattedComment = formattedParts.join(", ");

  // Update states
  setEditingCommentId(commentId);
  setEditedComment(formattedComment);
  setMentionedUsers(mentionedUsers || []);
  setMentionedUsersState(mentionedUsers || []);
  setErrors("");
  setEditCommentError("");
};




    const handleCancelEdit = () => {
      setEditingCommentId(null);
      setEditedComment("");
      setErrors("");
      setEditCommentError("");
    };
    const processMentionsForEdit = (commentText, allParticipants) => {
      const mentionRegex = /@([^\s@()]+)(?:\([^\)]*\))?/g;
      let match;
      let mentionList = [];

      while ((match = mentionRegex.exec(commentText)) !== null) {
        mentionList.push({
          type: match[1].toLowerCase() === "all" ? "all" : "user",
          name: match[1],
          index: match.index,
          raw: match[0],
        });
      }

      const allMentions = [];
      const singleMentions = [];

      for (let i = 0; i < mentionList.length; i++) {
        const currentMention = mentionList[i];
        const start = currentMention.index + currentMention.raw.length;
        const end =
          i < mentionList.length - 1
            ? mentionList[i + 1].index
            : commentText.length;

        let message = commentText.slice(start, end).trim();

        if (currentMention.type === "all") {
          allParticipants.forEach((attendee) => {
            allMentions.push({
              id: attendee._id,
              name: attendee.name,
              email: attendee.email,
              message,
            });
          });
        } else {
          const matchedUser = allParticipants.find(
            (u) =>
              u.name.split(" ")[0].toLowerCase() ===
              currentMention.name.toLowerCase()
          );

          if (matchedUser) {
            const remainingName = matchedUser.name
              .replace(new RegExp("^" + currentMention.name, "i"), "")
              .trim();
            if (remainingName && message.startsWith(remainingName)) {
              message = message.slice(remainingName.length).trim();
            }

            singleMentions.push({
              id: matchedUser._id,
              name: matchedUser.name,
              email: matchedUser.email,
              message,
            });
          }
        }
      }

      return {
        all: allMentions,
        singleMention: singleMentions,
      };
    };

    const handleSaveEditedComment = async (commentId) => {
      const htmlTagRegex = /<\/?[^>]+(>|$)/g;
      const specialCharRegex = /[<>$%^&*{}=+`~#|]/g;

      if (!editedComment.trim()) {
        setEditCommentError("Please enter comment");
        return;
      }

      if (htmlTagRegex.test(editedComment) || specialCharRegex.test(editedComment)) {
        setEditCommentError("HTML tags & special characters are not allowed!");
        return;
      }

      if (editedComment.trim().length < 3) {
        setEditCommentError("Comment must be at least 3 characters long.");
        return;
      }

      setIsEditingSaving(true);
      try {
        const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/updateActionComment/${commentId}`;
        const headerObject = {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        };


        const { all, singleMention } = processMentionsForEdit(
          editedComment,
          allParticipants
        );

        const payload = {
          commentDescription: editedComment,
          mentionId: { all, singleMention },
        };


        const response = await axios.put(webApiUrl, payload, headerObject);

        if (response.data.success) {
          const resData = response.data;
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setEditingCommentId(null);
          setEditedComment("");
          setMentionedUsers(resData.data?.mentionedUsers || []);
          setMentionedUsersState(resData.data?.mentionedUsers || []);
          setEditCommentError("");
          fetchComments();
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        if (handleApiError(error)) return;
        toast.error("Something went wrong. Please try again later.", {
          position: "top-right",
          autoClose: 4000,
          theme: "colored",
        });
      } finally {
        setIsEditingSaving(false);
      }
    };

const handleSaveComment = async () => {
  if (errors || !comment.trim()) {
    if (!comment.trim()) {
      setErrors("Please enter a comment");
    }
    return;
  }

  setIsSaving(true);

  try {
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/addActionComment/${actionId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    // Run mention extraction
    let mentionidData = processMentions(comment, attendees, assignedUsersArray);

    // Remove user's name or parts of name from message
    mentionidData.singleMention = mentionidData.singleMention.map((user) => {
      let message = user.message || "";

      // Remove first name, last name, or full name case-insensitively
      const nameParts = user.name.split(" ");
      nameParts.push(user.name); // Add full name

      nameParts.forEach((part) => {
        const partRegex = new RegExp(`\\b${part}\\b`, "gi");
        message = message.replace(partRegex, "").trim();
      });

      return {
        ...user,
        message: message,
      };
    });

    // Fallback if no mentions
    if (
      mentionidData.singleMention.length === 0 &&
      mentionidData.all.length === 0
    ) {
      const fallbackUsers = [
        ...(assignedUsersArray || []),
        ...(meetingCreator ? [meetingCreator] : []),
      ];

      mentionidData.singleMention = fallbackUsers.map((user) => ({
        id: user._id,
        name: user.name,
        email: user.email,
        message: comment.trim(),
      }));
    }

    // Deduplicate singleMention by ID
    const seenIds = new Set();
    mentionidData.singleMention = mentionidData.singleMention.filter((user) => {
      if (seenIds.has(user.id)) return false;
      seenIds.add(user.id);
      return true;
    });

    // Clean up comment: remove @mentions and their messages from commentDescription
    let cleanedComment = comment;

    mentionidData.singleMention.forEach((user) => {
      if (user.message) {
        const pattern = `@${user.name}\\s*${user.message}`;
        const regex = new RegExp(pattern.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "gi");
        cleanedComment = cleanedComment.replace(regex, "").trim();
      }
    });

    // Also remove raw mentions like "@User"
    mentionidData.singleMention.forEach((user) => {
      const regex = new RegExp(`@${user.name.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}(\\s|$)`, "gi");
      cleanedComment = cleanedComment.replace(regex, "").trim();
    });

    const payload = {
      userId: employeeData?.userData?._id,
      actionId: actionId,
      commentDescription: cleanedComment,
      mentionId: mentionidData,
    };

    

    const response = await axios.post(webApiUrl, payload, headerObject);

    if (response.data.success) {
      const resData = response.data;
      const mentionedNames = resData.data?.mentionedUsers || [];

      toast.success(resData.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });

      setComment("");
      setIsEditing(false);
      setErrors("");
      setMentionedUsers(mentionedNames);
      fetchComments();
    } else {
      toast.error(response.data.message, {
        position: "top-right",
        autoClose: 4000,
        theme: "colored",
      });
    }
  } catch (error) {
    if (handleApiError(error)) return;
  } finally {
    setIsSaving(false);
  }
};




const processMentions = (commentText, attendees = [], assignedUsersArray = []) => {
  const mentionRegex = /@([^\n@]+?)(?:\([^\)]*\))?(?=\s|$)/g;
  const mentionList = [];
  let match;

  // Combine attendees & assigned users (no dedupe)
  const combinedUsers = [...attendees, ...assignedUsersArray];

  while ((match = mentionRegex.exec(commentText)) !== null) {
    mentionList.push({
      raw: match[0],
      name: match[1].trim().split(" ")[0],
      fullName: match[1].trim(),
      type: match[1].trim().toLowerCase() === "all" ? "all" : "user",
      index: match.index,
    });
  }

  const individualMessages = [];
  let cleanedComment = commentText;

  // --- HANDLE @All
  const allMentionRegex = /@All(?:\([^\)]*\))?/gi;
  const allMentionMatch = allMentionRegex.exec(commentText);
  let allArray = [];

  if (allMentionMatch) {
    const allMentionIndex = allMentionMatch.index;
    const nextUserMention = mentionList.find(
      (m) => m.type === "user" && m.index > allMentionIndex
    );

    let allMessage = "";
    if (nextUserMention) {
      allMessage = commentText
        .substring(allMentionIndex + allMentionMatch[0].length, nextUserMention.index)
        .trim();
    } else {
      allMessage = commentText.substring(allMentionIndex + allMentionMatch[0].length).trim();
    }

    allArray = attendees.map((user) => ({
      id: user._id,
      name: user.name,
      email: user.email,
      message: allMessage,
    }));

    cleanedComment = commentText.substring(0, allMentionIndex).trim();
  }

  // --- HANDLE SPECIFIC MENTIONS
  mentionList.forEach((mention, index) => {
    if (mention.type === "user") {
      const user = combinedUsers.find(
        (u) =>
          u.name.toLowerCase() === mention.fullName.toLowerCase() ||
          u.name.split(" ")[0].toLowerCase() === mention.name.toLowerCase()
      );
      if (user) {
        const startIdx = mention.index + mention.raw.length;
        const endIdx = mentionList[index + 1]?.index || commentText.length;
        let msg = commentText.substring(startIdx, endIdx).trim();
        msg = msg.replace(allMentionRegex, "").trim();

        individualMessages.push({
          id: user._id,
          name: user.name,
          email: user.email,
          message: msg,
        });
      }
    }
  });

  const isAllMentioned = mentionList.some((m) => m.type === "all");

  // ✅ Fallback for normal comments (no mentions at all)
  if (mentionList.length === 0) {
    allArray = attendees.map((user) => ({
      id: user._id,
      name: user.name,
      email: user.email,
      message: commentText.trim(),
    }));
  }

  return {
    all: isAllMentioned || mentionList.length === 0 ? allArray : [],
    singleMention: individualMessages,
   // comment: cleanedComment.trim(), // ✅ Always include cleaned comment
  };
};

    const [deletingCommentId, setDeletingCommentId] = useState(null);

    const handleDeleteClick = (commentId) => {
      setDeletingCommentId(commentId);
      setCommentToDelete(commentId);
      setShowDeleteModal(true);
    };
    const handleCloseDeleteModal = () => {
      setShowDeleteModal(false);
      setDeletingCommentId(null);
    };

    const handleConfirmDelete = async () => {
      if (!commentToDelete) return;
      setIsDeleting(true);
      try {
        const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/action/deleteActionComment/${commentToDelete}`;
        const headerObject = {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        };

        const response = await axios.delete(webApiUrl, headerObject);
        if (response.data.success) {
          const resData = response.data;
          setShowDeleteModal(false);
          setCommentToDelete(null);
          setComment("");
          setIsEditing(false);
          setErrors("");
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          fetchComments();
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        if (handleApiError(error)) return;

      } finally {
        setIsDeleting(false);
      }
    };

    const isMeetingOrganiser =
      actionData?.singleActionDetails?.meetingDetail?.createdById?.toString() ===
        employeeData?.userData?._id?.toString()
        ? true
        : false;

    useEffect(() => {
      const scrollId = location.state?.scrollToId;

      if (scrollId) {
        const interval = setInterval(() => {
          const element = document.getElementById(scrollId);

          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
            clearInterval(interval);
          }
        }, 200);

        setTimeout(() => clearInterval(interval), 5000);
      }
    }, [location.state?.scrollToId]);

    

    return (
      <>
        <div className="mt-2 mb-3 details-form comments-div">
          <div className="col-12">
            <div className="comments-div-row d-flex gap-2 pb-3 comment-section-responsive">
              <div className="display640">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip-name">
                    {convertFirstLetterOfFullNameToCapital(userData?.name)}
                  </Tooltip>
                }
              >
                
                <span
                  className="attendee-username"
                  style={{
                    backgroundColor: userData?.profilePicture ? undefined : getColorFromId(userData?._id),
                  }}
                >
                  {userData?.profilePicture ? (
                    <img
                   className=" attendee-list-circle-img icon-image"
                      src={`${process.env.REACT_APP_API_URL}${userData.profilePicture}`}
                      alt=""
                      style={{
                   
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = "none";
                      
                        e.target.parentElement.style.backgroundColor = getColorFromId(
                          userData?._id
                        );
                        e.target.parentElement.innerText = customName(
                          userData?.name
                        );
                      }}
                    />
                  ) : (
                    customName(convertFirstLetterOfFullNameToCapital(userData?.name))
                  )}
                </span>           
              </OverlayTrigger>
              <span className="display991">{userData?.name}</span>
              </div>

              <div className="d-flex flex-column w-100">
                <div
                  className={`form-group ${(isEditing || comment.trim() !== "") && !editingCommentId
                      ? "comment-form"
                      : ""
                    }`}
                >
                  <MentionsInput
                    value={comment}
                    onChange={handleCommentChange}
                    onFocus={() => setIsEditing(true)}
                    placeholder="Add a comment with @mention..."
                    className="mention-input"
                  >
                    <Mention
                      trigger="@"
                      data={mentionData}
                      appendSpaceOnAdd={true}
                      displayTransform={(id, display) => `@${display}`}
                      renderSuggestion={(
                        entry,
                        search,
                        highlightedDisplay,
                        index,
                        focused
                      ) => (
                        <div
                          className={`mention-suggestion-item ${focused ? "focused" : ""}`}
                          key={entry.id}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <span
                              className="attendee-username"
                              style={{
                                backgroundColor: entry.profilePicture
                                  ? undefined
                                  : getColorFromId(entry.id),
                              // borderRadius: "50px",
                              //       padding: "4px 8px",
                              //       color: "#fff",
                              //       display: "flex",
                              //       alignItems: "center",
                              //       justifyContent: "center",
                              //       minWidth: "32px",
                              //       height: "32px",
                              }}
                            >
                              {entry.profilePicture ? (
                                <img
                                 className=" attendee-list-circle-img icon-image"
                                  src={`${process.env.REACT_APP_API_URL}${entry.profilePicture}`}
                                  alt=""
                                  style={{
                                    // width: "32px",
                                    // height: "32px",
                                    // borderRadius: "50%",
                                    // objectFit: "cover",
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    //e.target.style.display = "none";
                                    // e.target.parentElement.style.backgroundColor = getColorFromId(entry.id);
                                    // e.target.parentElement.innerText = customName(entry.name);
                                    e.target.parentElement.style.backgroundColor = getColorFromId(
                                      entry.id);
                              e.target.parentElement.innerText = customName
                              (entry.custom);
                                  }}
                                />
                              ) : (
                              entry.custom
                              )}
                            </span>

                            <div className="d-flex flex-column">
                              <span style={{ fontWeight: "500" }}>
                                {convertFirstLetterOfFullNameToCapital(entry.display)}
                              </span>
                              <span style={{ fontSize: "12px", color: "#888" }}>
                                {entry.email}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    />

                  </MentionsInput>
                  <p
                    style={{
                      fontSize: "12px",
                      color: comment.length > 500 ? "red" : "gray",
                    }}
                  >
                    {comment.length}/500 characters
                  </p>

                  {errors && (
                    <p style={{ color: "red", fontSize: "12px" }}>{errors}</p>
                  )}

                  <p className="nb">
                    NB:When tagging multiple users one after another, add a
                    space before each @mention
                  </p>
                </div>

                {(isEditing || comment.trim() !== "") && !editingCommentId && (
                  <div className="comment-btns d-flex">
                    <Button
                      className="me-2 add-btn Mom-btn"
                      onClick={handleSaveComment}
                      disabled={isSaving}
                    >
                      <p>{isSaving ? "Adding..." : "Save"}</p>
                    </Button>
                    <Button
                      className="create-meeting-button Mom-btn md-delete"
                      onClick={() => {
                        setIsEditing(false);
                        setComment("");
                        setErrors("");
                        setEditCommentError("");
                      }}
                    >
                      <p>Cancel</p>
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <div className="commentlist-div">
              {commentsList.length > 0 &&
                commentsList.map((comment) => {
                  const parsedDate = parse(
                    comment.createdAt,
                    "MMMM dd, yyyy hh:mm a",
                    new Date()
                  );
                  const timeAgo = formatDistanceToNow(parsedDate, {
                    addSuffix: true,
                  });

                  return (
                    <div className="comments-div-margin-top">
                    <div
                      key={comment._id}
                      className="comments-div-row d-flex gap-2"
                    >
                      <div className="comment-userimage">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-name">
                              {convertFirstLetterOfFullNameToCapital(
                                comment.userName
                              )}
                            </Tooltip>
                          }
                        >  
                                               
                          <span
                            className="attendee-username"
                            style={{
                              backgroundColor: comment.profilePicture
                                ? undefined
                                : getColorFromId(comment.userId),
                            
                            }}
                          >
                            {comment.profilePicture ? (
                              <img
                              className=" attendee-list-circle-img icon-image"
                                src={`${process.env.REACT_APP_API_URL}${comment.profilePicture}`}
                                alt=""
                                style={{
                              
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = "none";
                                
                                  e.target.parentElement.style.backgroundColor = getColorFromId(
                                    comment.userId
                                  );
                                  e.target.parentElement.innerText = customName(
                                    comment.userName
                                  );
                                }}
                              />
                            ) : (
                              // customName(
                              //   convertFirstLetterOfFullNameToCapital(comment.userName)
                              // )
                               <span className="attendee-name">
                                          {customName(comment?.userName)}
                                        </span>
                            )}
                          </span>
                        </OverlayTrigger>
                      </div>

                      <div
                        className="d-flex flex-column w-100"
                        key={comment._id}
                        id={comment._id}
                      >
                        <div className="d-flex resp-flex-col resp-align-items-start resp-gap-0">
                          <span className="comment-username me-2">
                            {convertFirstLetterOfFullNameToCapital(
                              comment.userName
                            )}
                            {comment.isEdited && (
                              <span
                                className="edited-label ms-2"
                                style={{
                                  fontSize: "12px",
                                  color: "#888",
                                }}
                              >
                                (edited)
                              </span>
                            )}
                          </span>
                          {showFullDate[comment._id] ? (
                            <span
                              className="comment-date-time"
                              onClick={() =>
                                setShowFullDate((prev) => ({
                                  ...prev,
                                  [comment._id]: false,
                                }))
                              }
                            >
                              {comment.createdAt}
                            </span>
                          ) : (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-name">
                                  {comment.createdAt}
                                </Tooltip>
                              }
                            >
                              <span
                                className="comment-date-time"
                                onClick={() =>
                                  setShowFullDate((prev) => ({
                                    ...prev,
                                    [comment._id]: true,
                                  }))
                                }
                              >
                                {timeAgo}
                              </span>
                            </OverlayTrigger>
                          )}
                        </div>

                        {editingCommentId === comment._id ? (
                          <div className="comment-edit-section mt-2">
                            <MentionsInput
                              value={editedComment}
                              onChange={handleEditCommentChange}
                              placeholder="Edit your comment with @mention..."
                              className="mention-input"
                            >
               
                              <Mention
                                trigger="@"
                                data={mentionData}
                                appendSpaceOnAdd={true}
                                displayTransform={(id, display) => `@${display}`}
                                renderSuggestion={(
                                  entry,
                                  search,
                                  highlightedDisplay,
                                  index,
                                  focused
                                ) => (
                                  <div
                                    className={`mention-suggestion-item ${focused ? "focused" : ""}`}
                                    key={entry.id}
                                  >
                                    <div className="d-flex align-items-center gap-2">
                                      <div className="d-flex align-items-center gap-2">
                                        <span
                                          className="attendee-username"
                                          style={{
                                            backgroundColor: entry.profilePicture
                                              ? undefined
                                              : getColorFromId(entry.id),
                                          
                                          }}
                                        >
                                          {entry.profilePicture ? (
                                            <img
className=" attendee-list-circle-img icon-image"
                                              src={`${process.env.REACT_APP_API_URL}${entry.profilePicture}`}
                                              alt=""
                                             
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.style.display = "none";
                                                e.target.parentElement.style.backgroundColor = getColorFromId(
                                                  entry.id
                                                );
                                                e.target.parentElement.innerText = customName(entry.custom);
                                              }}
                                            />
                                          ) : (
                                            entry.custom
                                          )}
                                        </span>

                                        <div className="d-flex flex-column">
                                          <span style={{ fontWeight: "500" }}>
                                            {convertFirstLetterOfFullNameToCapital(entry.display)}
                                          </span>
                                          <span style={{ fontSize: "12px", color: "#888" }}>{entry.email}</span>
                                        </div>
                                      </div>

                                      {/* <span>
          {convertFirstLetterOfFullNameToCapital(entry.display)}
        </span> */}
                                    </div>
                                  </div>
                                )}
                              />

                            </MentionsInput>
                            <p
                              style={{
                                fontSize: "12px",
                                color:
                                  editedComment.length > 500 ? "red" : "gray",
                              }}
                            >
                              {editedComment.length}/500 characters
                            </p>

                            {editCommentError && (
                              <p className="error-message">
                                {editCommentError}
                              </p>
                            )}
                            <div className="comment-btnss d-flex mt-2 mb-3">
                              <Button
                                className="me-2 add-btn Mom-btn"
                                onClick={() =>
                                  handleSaveEditedComment(comment._id)
                                }
                                disabled={isSaving}
                              >
                                <p>{isEditingSaving ? "Saving..." : "Save"}</p>
                              </Button>
                              <Button
                                className="create-meeting-button Mom-btn md-delete"
                                onClick={handleCancelEdit}
                              >
                                <p>Cancel</p>
                              </Button>
                            </div>
                          </div>
                        
                        ) : (
                          <>

<div className="comment-block">
  {/* {comment.commentDescription && (
    <div className="comment-description">{comment.commentDescription}</div>
  )} */}

  {/* CASE 1: @All */}
  {comment.allMention?.mentionedUsers?.length > 0 && (
    <div className="mentioned-users">
      {/* Show @All with tooltip */}
      <div className="mentioned-item">
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip-all`}>
              {comment.allMention.mentionedUsers.map((u) => `@${u.name}`).join(", ")}
            </Tooltip>
          }
        >
          <span className="mention-highlight">@All</span>
        </OverlayTrigger>
        {comment.allMention.mentionedUsers[0]?.message && (
          <span className="mention-message">
            {" "} - {comment.allMention.mentionedUsers[0].message}
          </span>
        )}
      </div>
    </div>
  )}

  {/* CASE 2: Single Mentions (shown after @All) */}
  {comment.singleMention?.mentionedUsers?.length > 0 && (
    <div className="mentioned-users">
      {comment.singleMention.mentionedUsers.map((u) => (
        <div key={u.id} className="mentioned-item">
          <span className="mention-highlight">@{u.name}</span>
          {u.message && <span className="mention-message"> - {u.message}</span>}
        </div>
      ))}
    </div>
  )}

  {/* CASE 3: Grouped Mentions */}
  {!comment.allMention?.mentionedUsers?.length &&
    !comment.singleMention?.mentionedUsers?.length &&
    comment.mentionedUsers?.length > 0 && (() => {
      const messageUserMap = {};

      comment.mentionedUsers.forEach((u) => {
        const message = (u.message || "").trim();
        if (messageUserMap[message]) {
          if (!messageUserMap[message].some((user) => user.id === u.id)) {
            messageUserMap[message].push({ id: u.id, name: u.name });
          }
        } else {
          messageUserMap[message] = [{ id: u.id, name: u.name }];
        }
      });

      const groupedMessages = Object.entries(messageUserMap);

      return (
        <div className="mentioned-users">
          {groupedMessages.map(([message, users], index) => {
            const firstThree = users.slice(0, 3);
            const remaining = users.slice(3);

            return (
              <div key={index} className="mentioned-item">
                <span className="mention-highlight">
                  {firstThree.map((user, idx) => (
                    <span key={idx}>
                      @{user.name}{idx < firstThree.length - 1 ? ", " : ""}
                    </span>
                  ))}
                  {remaining.length > 0 && (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-names-${index}`}>
                          {remaining.map((u) => `@${u.name}`).join(", ")}
                        </Tooltip>
                      }
                    >
                      <span className="plus-one-more-text">
                        +{remaining.length} more
                      </span>
                    </OverlayTrigger>
                  )}
                </span>
                {message && <span className="mention-message"> - {message}</span>}
              </div>
            );
          })}
        </div>
      );
    })()}
</div>





                            {/* {(isMeetingOrganiser || comment.userId === employeeData?.userData?._id) && ( */}
                            {comment.userId === employeeData?.userData?._id && (
                              <div className="edit-delete-btns d-flex">
                                <Button
                                  className="me-2 comment-edit-btn cm-btn"
                                  onClick={() =>
                                    handleEditComment(
                                      comment._id,
                                      comment.commentDescription,
                                      comment.mentionedUsers,
                                      comment.allMention,
                                      comment.singleMention
                                    )
                                  }
                                  disabled={isEditingSaving}
                                >
                                  Edit
                                </Button>

                                <Button
                                  className="comment-delete-btn cm-btn"
                                  onClick={() => handleDeleteClick(comment._id)}
                                  disabled={deletingCommentId === comment._id}
                                >
                                  {deletingCommentId === comment._id
                                    ? "Deleting..."
                                    : "Delete"}
                                </Button>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                      </div>
                  );
                })}
            </div>
          </div>
        
        </div>

        <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this comment ?</Modal.Body>
          <Modal.Footer>
            <Button
              className="add-btn Mom-btn"
              onClick={handleCloseDeleteModal}
            >
              <p>Cancel</p>
            </Button>
            <Button
              className="create-meeting-button Mom-btn md-delete"
              onClick={handleConfirmDelete}
            >
              <p>Delete</p>
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
);

export default ActionComments;
